import "./App.css";
import AppRoutes from "./Routes/routes";
import "./Component/Tabs/Tabs.css";
import "./Component/CreateCommunity/Createcommunity.css";
import "./Component/SuperAdmin/SuperAdmin.css";
import "./Component/SuperAdmin/Superadmincommunity/Superadmincommunity.css";
import "./Component/User Management/Usermanagement.css";
import "./Component/UploadDocument/uploadDocument.css";
import "./Component/SuperAdmin/SuperadminApproval/SuperadminApproval.css";
import "./Component/SuperAdmin/SuperadminClaim/Superadminclaim.css";
import "./Component/SuperAdmin/SuperAdminProfile/Superadminprofile.css";
import { ToastContainer } from "react-toastify";

function App() {
  return (
    <>
      <AppRoutes />
      <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        limit={3}
        sx={{
          zIndex: 1000,
        }}
      />
    </>
  );
}

export default App;
